import client from '../lib/http-client';

const endpoint = '/rundownItems';

export default {
	// Create
	create(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = `${endpoint}`;
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	/**
	 * Create Bulk
	 *
	 * @param {Object[]} users Users
	 * @param {string} users.email Email
	 * @param {string} users.password Password
	 * @param {string} users.language Language
	 * @param {string} users.firstName First Name
	 * @param {string} users.gender Gender
	 * @param {*} cb Callback
	 * @param {*} errorCb Error Callback
	 */
	createBulk(rundownId, items, cb, errorCb) {
		const url = `${endpoint}/bulk/create`;
		const params = {
			rundown_id: rundownId,
			rundownItems: JSON.stringify(items),
		};
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get
	get(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get by Slug
	getBySlug(slug, cb, errorCb) {
		const url = `${endpoint}/slug/${slug}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get List
	getList(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = endpoint;
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Bulk Delete
	bulkDelete(ids, cb, errorCb) {
		const params = {
			ids: JSON.stringify(ids),
		};
		const url = `${endpoint}/bulk/delete`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Update
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Bulk Update
	bulkUpdate(params, cb, errorCb) {
		const url = `${endpoint}/bulk/update`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// playStop
	togglePlay(id, status, params, cb, errorCb) {
		const url = `${endpoint}/${id}/${status}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// toggleHide
	toggleHide(id, status, cb, errorCb) {
		const url = `${endpoint}/toggleHide/${id}/${status}`;
		client.put(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	removeVCam(slug, vcamid, cb, errorCb) {
		const url = `${endpoint}/removeVCam/${slug}/${vcamid}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	hideVCam(slug, vcamid, cb, errorCb) {
		const url = `${endpoint}/hideVCam/${slug}/${vcamid}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	toggleOffVCam(slug, vcamid, status, itemId, cb, errorCb) {
		const url = `${endpoint}/turnOffVCam/${slug}/${vcamid}/${status}/${itemId}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	muteVCam(slug, vcamid, status, cb, errorCb) {
		const url = `${endpoint}/muteVCam/${slug}/${vcamid}/${status}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	toggleSoloVideo(slug, status, cb, errorCb) {
		const url = `${endpoint}/soloVideo/${slug}/${status}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	muteAllVCam(slug, vcamid, cb, errorCb) {
		const url = `${endpoint}/muteAllVCam/${slug}/${vcamid}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// toggleHide
	hideLive(id, cb, errorCb) {
		const url = `${endpoint}/hideItem/${id}/hide`;
		client.put(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// toggleHide
	showLive(id, cb, errorCb) {
		const url = `${endpoint}/showItem/${id}/show`;
		client.put(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// forceReset
	forceReset(id, cb, errorCb) {
		const url = `${endpoint}/forceReset/${id}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// forcePlay
	forcePlay(id, cb, errorCb) {
		const url = `${endpoint}/forcePlay/${id}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// stop all
	stopAll(id, status, cb, errorCb) {
		const url = `${endpoint}/stopAll/${id}/${status}`;
		client.post(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// reset Preview
	resetPreview(rundownSlug, cb, errorCb) {
		const url = `${endpoint}/reset/${rundownSlug}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Delete
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export
	export(type, params, cb, errorCb) {
		const url = `${endpoint}/export/${type}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Reorder
	reorder(params, cb, errorCb) {
		const url = `${endpoint}/reorder/item/order`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.put(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// play live
	playLive(id, cb, errorCb) {
		const url = `${endpoint}/${id}/playLive`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// stop live
	stopLive(id, cb, errorCb) {
		const url = `${endpoint}/${id}/stopLive`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	mute(id, status, cb, errorCb) {
		const url = `${endpoint}/mute/${id}/${status}`;
		client.put(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// cache Display
	cacheDisplay(id, params, cb, errorCb) {
		const url = `${endpoint}/cacheDisplay/${id}`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// cache Display
	renderFrame(status, params, cb, errorCb) {
		const url = `${endpoint}/download/${status}/LottieImage`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// playStop
	accessItemLink(id, status, cb, errorCb) {
		const url = `${endpoint}/encode/${id}/${status}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	togglePauseTimer(slug, id, status, cb, errorCb) {
		const url = `${endpoint}/toggleTimer/${slug}/${id}/${status}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
